import { formatDate } from '@/composables/formatDate';

export function currentStatusText(company) {
  const campaign = company.campaign
  const statuses = (company.crm_statuses || []).filter(status => campaign && status.campaign && status.campaign.id == campaign.id)
  if (statuses.length === 0) {
    return '--'
  }
  const latest = statuses.reduce((acc, curr) => new Date(acc.created_on) > new Date(curr.created_on) ? acc : curr)
  return `${latest.crm_status.status_name} ${new Date(latest.created_on).toLocaleDateString()}`
}

export function nextActionText(company) {
  if (!company.crm_next_action) {
    return '--'
  }
  const dueDate = company.crm_next_action_due_date
  return dueDate ? `${company.crm_next_action} (due ${formatDate(dueDate)})` : company.crm_next_action
}
